module.exports = __webpack_public_path__ + "static/2018-header-258f9923b1f17146d350375b3d8913fe.jpg";